import { VesDamageKostenbelegModel } from '../../../../../shared/models/view/VesDamageKostenbeleg';
import { DocumentsBillsModel } from '../../../../../shared/models/view/DocumentsBills';
import { AppUtils } from '../../../../../shared/utils/index';

/**
 * Model class for the DocumentsBills form
 */
export class DocumentsBillsFormModel extends DocumentsBillsModel {

	constructor(initialProperties?: Partial<DocumentsBillsModel>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	private behandlungskostenBelege: { [id: string]: VesDamageKostenbelegModel };
	private medikamenteBelege: { [id: string]: VesDamageKostenbelegModel };
	private patiententransportBelege: { [id: string]: VesDamageKostenbelegModel };

	set BehandlungskostenBelege(value: { [id: string]: VesDamageKostenbelegModel }) {
		this.behandlungskostenBelege = value;
	}

	get BehandlungskostenBelege(): { [id: string]: VesDamageKostenbelegModel } {
		return this.behandlungskostenBelege;
	}

	set MedikamenteBelege(value: { [id: string]: VesDamageKostenbelegModel }) {
		this.medikamenteBelege = value;
	}

	get MedikamenteBelege(): { [id: string]: VesDamageKostenbelegModel } {
		return this.medikamenteBelege;
	}
	set PatiententransportBelege(value: { [id: string]: VesDamageKostenbelegModel }) {
		this.patiententransportBelege = value;
	}

	get PatiententransportBelege(): { [id: string]: VesDamageKostenbelegModel } {
		return this.patiententransportBelege;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): DocumentsBillsFormModel {
		let belegeDict: { [id: string]: VesDamageKostenbelegModel };
		const result = new DocumentsBillsFormModel(DocumentsBillsModel.createFromObject(dataObject));
		AppUtils.Helper.mapObject(dataObject, result, (key, value) => {
			switch (key) {
				case 'behandlungskostenBelege':
				case 'medikamenteBelege':
				case 'patiententransportBelege':
					belegeDict = {};
					if (value) {
						Object.keys(value).forEach(key => {
							belegeDict[key] = VesDamageKostenbelegModel.createFromObject(value[key]);
						});
					}
					return belegeDict;
				default:
					return (result as { [key: string]: any })[key];
			}
		});
		return result;
	}
}